import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const DatabaseBlockView = ({ node }) => {
    const { t } = useTranslation();
    const { id, emoji, text } = node.attrs;

    return (
        <NodeViewWrapper>
            <div className="doc-database-block" data-id={id} contentEditable="false" suppressContentEditableWarning>
                <div className="header">
                    <div className="name-tag">
                        <span className="tag-emoji">{emoji || '🗄️'}</span>
                        <span className="tag-text">{text}</span>
                        <button className="copy-uid-btn" title="Copiar UID" data-uid={id}>
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/></svg>
                        </button>
                    </div>
                </div>
                <div className="body">
                    Cargando vista previa de {text}...
                </div>
            </div>
        </NodeViewWrapper>
    );
};

export const DatabaseExtension = Node.create({
    name: 'databaseBlock',
    group: 'block',
    atom: true,

    addAttributes() {
        // Integración main→dev, epic D2: los atributos se serializan como `data-*` para que el
        // bloque sobreviva un save+reload (`main` los emitía como atributos sueltos —
        // `id`/`emoji`/`text` — que `parseHTML` no volvía a leer → se perdía el bloque).
        return {
            id: {
                default: null,
                parseHTML: (e) => e.getAttribute('data-id') || e.getAttribute('id'),
                renderHTML: (a) => (a.id ? { 'data-id': a.id } : {}),
            },
            emoji: {
                default: '🗄️',
                parseHTML: (e) => e.getAttribute('data-emoji') || e.querySelector('.tag-emoji')?.textContent || '🗄️',
                renderHTML: (a) => (a.emoji ? { 'data-emoji': a.emoji } : {}),
            },
            text: {
                default: '',
                parseHTML: (e) => e.getAttribute('data-text') || e.querySelector('.tag-text')?.textContent || '',
                renderHTML: (a) => (a.text ? { 'data-text': a.text } : {}),
            },
        };
    },

    parseHTML() {
        return [{ tag: 'div.doc-database-block' }];
    },

    renderHTML({ HTMLAttributes }) {
        return ['div', mergeAttributes({ class: 'doc-database-block' }, HTMLAttributes)];
    },

    addNodeView() {
        return ReactNodeViewRenderer(DatabaseBlockView);
    },
});
